import React, { useEffect, useState } from 'react';
import { useModal } from '../common/context/ModalProvider';

export default function Modal() {
  const { isModalOpen, hideModal, modalContent, modalHeader } = useModal();
  const [modalPositionClass, setModalPositionClass] = useState('bottom-[-100vh]');

  const setModalThemeColor = (color: string) => {
    document?.querySelector('meta[name="theme-color"]')?.setAttribute('content', color);
  };

  useEffect(() => {
    if (isModalOpen) {
      setModalPositionClass('bottom-0');
      setModalThemeColor('#000000');
    }
  }, [isModalOpen]);

  if (!isModalOpen) return null;

  return (
    <main>
      <div className='fixed top-0 left-0 bg-black opacity-10 w-screen h-screen z-40'></div>
      <div
        className={`fixed w-screen h-[97vh] rounded-lg bg-[#f2f2f7] dark:bg-neutral-900 left-0 z-50 transition-all duration-300 ${modalPositionClass} `}
      >
        <article className=' rounded-lg  px-4 py-3 flex items-center justify-center'>
          <button
            className='text-md text-blue-500 dark:text-orange-500 absolute left-3'
            onClick={() => {
              setModalPositionClass('bottom-[-100vh]');
              setTimeout(() => {
                hideModal();
                setModalThemeColor('#f2f2f7');
              }, 100);
            }}
          >
            Cancel
          </button>

          <strong className='text-black dark:text-white'>{modalContent && modalContent['title']}</strong>

          <div className='absolute right-3'>{modalHeader.right}</div>
        </article>
        <section className='p-4 overflow-y-auto overflow-x-hidden h-[86vh]'>
          {modalContent && <div>{modalContent['content']}</div>}
        </section>
      </div>
    </main>
  );
}
